import React from 'react';
import AsyncMultiSelect from './AsyncMultiSelect';
import { searchUsersPublic } from '../api';

export default function UsersSelect({ value, onChange, max = 20 }) {
  return (
    <AsyncMultiSelect
      label="Travel companions"
      placeholder="Search users by username"
      value={value}
      onChange={onChange}
      searchFn={searchUsersPublic}
      max={max}
    />
  );
}

